import React, { useEffect, useState } from 'react';
import { useCartLink } from './Shared';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const href = useCartLink();
  useEffect(() => {
    const target = document.querySelector('[data-cta="hero"]') || document.querySelector('[data-cta="legal"]');
    if (!target) {
      setVisible(false);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0,
      rootMargin: '0px 0px -16px 0px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <div className={`sticky-cta-wrap${visible ? ' sticky-cta-wrap--visible' : ''}`} aria-hidden={!visible} data-id="element-153">
      <a href={href} target="_blank" rel="noopener noreferrer" data-cta="sticky" className="sticky-cta" tabIndex={visible ? 0 : -1} data-id="element-154">
        <span className="sticky-cta__icon" aria-hidden="true" data-id="element-155">
          ✦
        </span>
        <span className="sticky-cta__label" data-id="element-156">Quiero el bundle</span>
        <span className="sticky-cta__sep" aria-hidden="true" data-id="element-157">
          ·
        </span>
        <span className="sticky-cta__oldprice" aria-hidden="true" data-id="element-158">
          $47
        </span>
        <span className="sticky-cta__price" data-id="element-159">$17</span>
      </a>
    </div>;
}